var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sdr-box book-with-us-box",
      staticStyle: { border: "1px solid #ab3b7a" },
    },
    [
      _c("h4", [_vm._v(_vm._s(_vm.needhelp[_vm.getCurrentLocale]))]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _c("i", { staticClass: "soap-icon-trunk-3 circle" }),
          _vm._v(" "),
          _c("h5", { staticClass: "title" }, [
            _c("a", { staticClass: "skin-color", attrs: { href: "#" } }, [
              _vm._v(_vm._s(_vm.sideboxhelptext1[_vm.getCurrentLocale])),
            ]),
          ]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.sideboxhelptext2[_vm.getCurrentLocale]))]),
        ]),
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-medium icon-check uppercase full-width",
          attrs: { type: "submit" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              _vm.onClick_GoBack()
            },
          },
        },
        [_vm._v(_vm._s(_vm.goback[_vm.getCurrentLocale]))]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }